<template>
<div class="base-list-header">
  <div class="list-item">
      <slot></slot>
  </div>
  <v-divider></v-divider>
</div>
    <!-- total -->
    <!-- <v-layout row
              wrap
              align-center>
      <v-flex xs5>
      </v-flex>
      <v-flex xs1>總計
      </v-flex>
      <v-flex xs1>ghgh
      </v-flex>
      <v-flex xs1>ggg
      </v-flex>
      <v-flex xs2>hghghhgh
      </v-flex>
      <v-flex xs2>
        <base-edit-btn></base-edit-btn>
      </v-flex>
    </v-layout> -->

</template>
<script>
export default {
  name: 'base-list-header',
  // props: {
  // },
  data () {
    return {}
  },
  methods: {}
}
</script>
<style lang="stylus" scoped>
.base-list-header
  .list-item //依照標籤內區塊內容自動分
    display: flex;
    align-items: center;
    word-break: break-all;
    text-align center;
    padding: 10px 0;
    *
      flex:1
hr
  padding: 10px 0;
@media only screen and (min-width: 1025px){
 .base-list-header .list-item>*{
    flex: 1
    }
 .base-list-header .list-item>*:first-child{
    flex: 2
    }
  }

</style>
